export default __webpack_public_path__ + "static/media/Acer-Swift-5-Pro-intel-laptop.388dc8fd.jpg";